import { Howl } from 'howler';
import { useCallback, useEffect, useRef } from 'react';

export const useAudioPlayerSaveProgress = (
    sound: Howl,
    isPlaying: boolean,
    onProgressSave: (progressPercentage: number) => Promise<void>,
) => {
    const lastSavedProgressRef = useRef(0);

    const updateProgress = useCallback(() => {
        if (sound.state() !== 'loaded' || sound.duration() === 0) {
            return;
        }
        const progressPercentage = +(sound.seek() / sound.duration()).toFixed(2);

        if (progressPercentage === lastSavedProgressRef.current) {
            return;
        }

        onProgressSave(progressPercentage);

        lastSavedProgressRef.current = progressPercentage;
    }, [sound, onProgressSave]);

    useEffect(() => {
        sound.on('pause', () => {
            updateProgress();
        });
    }, [sound, updateProgress]);

    useEffect(() => {
        window.addEventListener('beforeunload', updateProgress);

        return () => {
            window.removeEventListener('beforeunload', updateProgress);
        };
    }, [updateProgress]);

    useEffect(() => {
        return () => {
            updateProgress();
        };
    }, [updateProgress]);

    useEffect(() => {
        if (!isPlaying) {
            return;
        }
        const intervalId = setInterval(() => {
            updateProgress();
        }, 10000);

        return () => {
            clearInterval(intervalId);
        };
    }, [isPlaying, updateProgress]);
};
